import React from 'react'
import style from './style.module.css'
export const PageFooter = () => {
  return (
          <div className={style.pageFooter}>
            <p>This is an automated email. PLease do not reply.</p>
            <p>Takeaway.com European Operations B.V. | Oosterdoksstraat 80 | 1011DK</p>
            <p>Amsterdam © 2026 Takeaway.com</p>
          </div>
  )
}

export default PageFooter